module.exports = "<button md-button class=\"wg-icon\" mdTooltip=\"{{ 'ADD_TO_PLAYLIST' | tooltip }} \" mdTooltipPosition='{{aboveTooltip}}' color='primary' *ngIf=\"song || playlist\"\n  (click)=\"addToPlaylist($event)\">\n    <i class=\"material-icons icon icon add-to-playlist\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/songs/add-to-playlist/add-to-playlist.component.html
// module id = ./src/app/songs/add-to-playlist/add-to-playlist.component.html
// module chunks = main